import { Box, Typography } from '@mui/material'
import { memo, useMemo } from 'react'
import Icon from '../icon'
import { copyToClipboard } from '../../utils/utils'

const ChatPublicShareableLink = ({ data }) => {
  const uuid = useMemo(() => data?.publicLinkToken, [data])
  const candidateName = useMemo(() => data?.candidateName, [data])
  const expiryTime = useMemo(() => data?.publicLinkExpiryTime, [data])
  const url = useMemo(() => `${window.location.origin}/share/${uuid}`, [uuid])
  const expiryDate = useMemo(() => new Date(expiryTime), [expiryTime])
  const isExpired = useMemo(() => expiryDate < new Date(), [expiryDate])

  const getExpiryText = useMemo(() => {
    if (isExpired) return 'This link has expired.'

    const diffMs = expiryDate - new Date()
    const diffHours = Math.ceil(diffMs / (1000 * 60 * 60))
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24))

    if (diffHours >= 24) {
      return `This link will expire in ${diffDays} day${diffDays > 1 ? 's' : ''}.`
    }

    return `This link will expire in ${diffHours} hour${diffHours > 1 ? 's' : ''}.`
  }, [isExpired, expiryDate])

  return (
    <Box sx={{ gap: '4px', display: 'flex', flexDirection: 'column' }}>
      <Typography fontSize={'13px'}>
        A shareable summary link has been generated for{' '}
        <strong>{candidateName}</strong>.
      </Typography>
      <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: '13px' }}
        >
          {url}
        </a>
        <Icon
          icon={'solar:copy-bold'}
          hoverEffect
          onClick={() => copyToClipboard(url)}
        />
      </Box>
      <Typography variant="caption">{getExpiryText}</Typography>
    </Box>
  )
}

export default memo(ChatPublicShareableLink)
